import HeroPanels from "./HeroPanels";
import ShoppingList from "./ShoppingList";
import Subscribe from "./Subscribe";

function Home() {
  return (
    <div
      className="home"
      style={{
        width: "100vw",
        maxWidth: "100vw",
        margin: 0,
        padding: 0,
        overflowX: "hidden",
      }}
    >
      <HeroPanels />
      <ShoppingList />
      <Subscribe />
    </div>
  );
}

export default Home;
